export const CONTROL_SIZE = 'sm'
